jQuery(function($){
	// if mobile device skip popup
	if($('body').hasClass('is-mobile')) {
		return;
	}
	// load modal popup
	$('.modal-link').click(function(e){
		e.preventDefault();
		var href = $(this).attr('href');
		if (href == null) {
			// class attached to button (contact gsa member)
			var parentForm = $(this).closest('form');
			var mid = parentForm.find('input[name=mid]').val();
			var oid = parentForm.find('input[name=oid]').val();
			href = parentForm.attr('action') + '?od_ajaxCall=true&mid=' + mid + '&oid=' + oid;
		} else {
			// hide modal if link to page is current page
			if(href.replace(/\//g, '') == window.location.pathname.substr(1).replace(/\//g, '')) {
				return false;
			}
			// class attached to link
			href = href + '?od_ajaxCall=true';
		}
		var height = parseFloat($(window).height() * 0.80);
	  	$('.modal-frame').attr('src', href);
		$('.modal-frame').height(height);
	    $('#gsa-modal').modal({show:true});
	    $('#gsa-modal .modal-backdrop').remove();
	    // $('#gsa-modal .modal-backdrop').css('background', 'transparent');
	});
});
